import { Outlet } from "react-router-dom";
import FrontHeader from "../../shared/FrontHeader";
import { setTitle } from "../../helpers/MetaTag";
import CommonSideBar from "../shared/CommonSideBar";

const FrontLayout = ({ metaTitle, isSidebar = false }) => {
  setTitle(metaTitle);

  return (
    <div className="dark:bg-darkBg pt-32 bg-gray-100 mt-5">
      <FrontHeader />

      <div className="relative w-full max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-5xl 3xl:max-w-6xl mx-auto mb-7 flex gap-5 items-start">
        {
          isSidebar && <div className="w-[30%] sticky top-36">
            <CommonSideBar />
          </div>
        }

        <div className={`${isSidebar=== true ? "w-[70%]":"w-full"}`}>
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default FrontLayout;